// extracted by mini-css-extract-plugin
export default {"container":"styles_container__D+YIe","headerText":"styles_headerText__VouPU","image_link":"styles_image_link__lvUAE","image":"styles_image__i5J5v"};